import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Input from '../../modules/Input';
import Button from '../../modules/Button';
import InputGroup from '../../modules/InputGroup';
import FormButtonPanel from '../../modules/FormButtonPanel';
import AlertBox from '../../modules/AlertBox';
import HtmlEditor from '../../modules/HtmlEditor';

import * as formScroller from '../../../services/forms/scroller';
import AlertMessage from "../../modules/AlertMessage/index";
import FormatAlertMessage from "../../modules/FormatAlertMessage/index";

class Licence extends React.Component {

    render() {
        const {
            submitSucceeded,
            submitFailed,
            handleSubmit,
            pristine,
            submitting,
            error
        } = this.props;

        return (
            <div>
                <AlertMessage>
                    {(submitSucceeded || submitFailed) && (
                        <AlertBox
                            theme={submitSucceeded ? "success" : "danger"}
                        >
                            {submitSucceeded && (
                                'The licence has been saved.'
                            )}
                            {submitFailed && error && (
                                <FormatAlertMessage
                                    genericMessage={'There was a problem saving the licence.'}
                                    error={error}
                                />
                            )}
                        </AlertBox>
                    )}
                </AlertMessage>

                <form onSubmit={handleSubmit}>
                    <InputGroup>
                        <Field name="name" component={Input} type="text" label="Name" required="true" />
                    </InputGroup>

                    <InputGroup className="licence-viewer">
                        <Field name="content" component={HtmlEditor} type="text" label="Licence" required="true" />
                    </InputGroup>

                    <FormButtonPanel position="bottom">
                        <Button disabled={pristine || submitting} type="submit">Save</Button>
                    </FormButtonPanel>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'licence',
    onSubmitSuccess: formScroller.scrollToTop,
    onSubmitFail: formScroller.scrollToFirstError
})(Licence);